<template>
    <div class="notes-history-modal modal-card">
        <header class="modal-card-head">
            <p class="title modal-card-title">Notes history: <b>{{ projectService.title }}</b></p>
        </header>
        <section class="modal-card-body">
            <div class="column is-12">
                <o-field>
                    <o-input
                        type="search"
                        v-model="filters.searchTerm"
                        placeholder="Search notes"
                        icon="search"
                    />
                </o-field>
            </div>
            <o-table
                backend-sorting
                backend-pagination
                class="notes-history-table is-responsive is-responsive-xs-desktop"
                v-if="isTableVisible"
                :bordered="table.bordered"
                :checkable="table.checkable"
                :data="paginatedData"
                :default-sort="table.defaultSort"
                :default-sort-direction="table.defaultSortDirection"
                :hoverable="table.hoverable"
                :loading="loading"
                :mobile-cards="table.mobileCards"
                :narrowed="table.narrowed"
                :paginated="table.paginated"
                :pagination-simple="table.paginationSimple"
                :per-page="table.perPage"
                :striped="table.striped"
                @page-change="onPageChange"
                @sort="onSort"
            >
                <template slot-scope="props">
                    <o-table-column
                        field="value"
                        label="Notes"
                        :sortable="true"
                    >{{ props.row.value }}</o-table-column>
                    <o-table-column
                        field="user"
                        label="User"
                        :sortable="true"
                    >{{ props.row.actor.full_name }}</o-table-column>
                    <o-table-column
                        field="created_at"
                        label="Created at"
                        :sortable="true"
                    >{{ props.row.created_at }}</o-table-column>
                </template>
                <div slot="empty" class="has-text-centered">
                    This table is empty!
                </div>
            </o-table>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
        </footer>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Table from './../../mixins/Table'

    export default {
        mixins: [Table],
        props: ['projectService'],

        components: {
        },

        computed: {
        },

        data () {
            return {
                data: [],
                filters: {
                    field: "notes",
                    searchTerm: '',
                    reference_id: this.projectService.id,
                    reference_type: "project-service",
                },
                isTableVisible: true,
                loading: false,
                table: {
                    bordered: false,
                    checkable: false,
                    defaultSort: ['created_at', 'desc'],
                    defaultSortDirection: 'desc',
                    hoverable: true,
                    mobileCards: true,
                    narrowed: false,
                    paginated: true,
                    paginationSimple: false,
                    perPage: 10,
                    striped: true,
                },
                tableName: 'notes-history',
                total: 0,
            }
        },

        mounted () {
            this.fetchPaginatedData()
        },

        methods: {
            fetchData(params) {
                return axios.post(`/api/historical-data/list`, params)
                .then(res => {
                    this.data = res.data.data
                    return res
                })
            },
            itemsByIds() {
                return this.data
            },
        },

        watch: {
            filters: {
                deep: true,
                handler() {
                    this.fetchPaginatedData()
                },
            },
        },
    }
</script>

<style>
.notes-history-modal {
  width: 100%; }

.table-wrapper {
  min-height: auto; }

</style>
